import React from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import RulesDTO from '../../../dto/RulesDTO';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import { createClearObject } from '../../../utils/utils';
import RangeDatePicker from '../../../components/fields/RangeDatePicker/RangeDatePicker';
import CustomSelectInputWithHelper from '../../../components/fields/SelectInput/CustomSelectInputWithHelper';
import { loadZoneList } from '../../Zones/actions';
import FieldDTOWithCol from '../../../components/fields/Abstract/FieldDTOWithCol';
import {
  DAYS_LIST,
  PROPULSION_TYPES_LIST, RATE_APPLIES_WHEN_LIST,
  RATE_RECURRENCES_LIST,
  RULE_UNITS_LIST,
  RULES_TYPE_LIST,
  VEHICLE_TYPES_LIST,
} from '../../../configs';
import SelectGeographies from './SelectGeographies';
import { loadGeographyList } from '../../Geography/actions';
import Switches from '../../../components/fields/Switches/Switches';
import TimePicker from '../../../components/fields/TimePicker/TimePicker';

export default function FilterForm(props) {
  const {
    onHide, getValues, reset, defaultValues, setValue, control,
  } = props;
  const { formatMessage } = useIntl();
  const DTO = new RulesDTO();
  const attributes = DTO.getAttributesByName();
  const clear = () => {
    const fields = getValues();
    const cleared = createClearObject(fields);
    reset({ ...cleared, ...defaultValues });
  };
  const save = () => {
    onHide();
  };

  return (
    <Dialog
      className={classNames('full-filter')}
      onClose={save}
      open
    >
      <DialogTitle header={formatMessage({ id: 'filters' })} title={<Icons onClick={onHide} customIcon icon="close" className="close" />} />
      <DialogContent className="hff-content custom-scroll-theme">
        <form className="filter-content-wrapper">
          <FieldDTO
            control={control}
            component={TextInputWithLabel}
            dtoObject={attributes.name}
            hideSmallButtons
            showArrowIcon
            usePortal
            withLabel
            variant="material"
          />
          <FieldDTOWithCol
            control={control}
            dtoObject={attributes.geographies}
            usePortal
            // addPlaceholder
            component={SelectGeographies}
            portalClassName="executor-selector"
            loadAction={loadGeographyList}
            optionFormatter={item => ({ value: item.geography_id, name: item.name })}
            filterName="full_name"
            variant="material"
            withLabel
            className="mb-3"
            multiple
          />
          <FieldDTOWithCol
            control={control}
            type="text"
            component={CustomSelectInput}
            dtoObject={attributes.rule_type}
            variant="material"
            withLabel
            options={RULES_TYPE_LIST}
            className="mb-3"
          />
          <FieldDTOWithCol
            control={control}
            type="text"
            component={CustomSelectInput}
            dtoObject={attributes.rule_units}
            variant="material"
            withLabel
            options={RULE_UNITS_LIST}
            className="mb-3"
          />
          <FieldDTOWithCol
            control={control}
            type="text"
            component={CustomSelectInput}
            dtoObject={attributes.vehicle_types}
            variant="material"
            withLabel
            options={VEHICLE_TYPES_LIST}
            className="mb-3"
          />
          <FieldDTOWithCol
            control={control}
            type="text"
            component={CustomSelectInput}
            dtoObject={attributes.propulsion_types}
            variant="material"
            withLabel
            options={PROPULSION_TYPES_LIST}
            className="mb-3"
          />
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.minimum}
            variant="material"
            withLabel
            className="mb-3"
          />
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.maximum}
            variant="material"
            withLabel
            className="mb-3"
          />
          <FieldDTOWithCol
            control={control}
            type="text"
            component={Switches}
            dtoObject={attributes.inclusive_minimum}
            variant="material"
            withLabel
            className="mb-3"
          />
          <FieldDTOWithCol
            control={control}
            type="text"
            component={Switches}
            dtoObject={attributes.inclusive_maximum}
            variant="material"
            withLabel
            className="mb-3"
          />
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.rate_amount}
            variant="material"
            withLabel
            className="mb-3"
          />
          <FieldDTOWithCol
            control={control}
            type="text"
            component={CustomSelectInput}
            dtoObject={attributes.rate_recurrence}
            variant="material"
            withLabel
            options={RATE_RECURRENCES_LIST}
            className="mb-3"
          />
          <FieldDTOWithCol
            control={control}
            type="text"
            component={CustomSelectInput}
            dtoObject={attributes.rate_applies_when}
            variant="material"
            withLabel
            options={RATE_APPLIES_WHEN_LIST}
            className="mb-3"
          />
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TimePicker}
            dtoObject={attributes.start_time}
            variant="material"
            withLabel
            className="mb-3"
          />
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TimePicker}
            dtoObject={attributes.end_time}
            variant="material"
            withLabel
            className="mb-3"
          />
          <FieldDTOWithCol
            control={control}
            type="text"
            component={CustomSelectInput}
            dtoObject={attributes.days}
            variant="material"
            withLabel
            options={DAYS_LIST}
            multiple
            className="mb-3"
            namePrefix="schedule."
          />
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.value_url}
            variant="material"
            withLabel
            textarea
            className="mb-3"
          />
        </form>
      </DialogContent>
      <DialogFooter className="hff-footer">
        {/* <div className="hff-footer-text">{formatMessage({ id: 'find' }, { count: meta.count })}</div> */}
        <div className="hff-footer-buttons hff-center">
          {/* <Button className="hff-clear-show" onClick={save}>{formatMessage({ id: 'show' })}</Button> */}
          <Button className="hff-clear-data" variant="secondary" onClick={clear}>{formatMessage({ id: 'clear.all' })}</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
